<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form
         @submit.stop.prevent="onSubmit"
        novalidate
      >
        <b-row>
          <b-col cols="6">
              <b-form-group label="Name" label-for="name">
                  <b-form-input
                    id="name"
                    type="text"
                    :state="chkState('name')"
                    v-model.lazy.trim="$v.form.name.$model"
                    aria-describedby="liveFeedbackName"
                    placeholder="Enter Product Name"
                    autofocus
                  />
                  <b-form-invalid-feedback id="liveFeedbackName">
                    This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Category"
              label-for="catname"
            >
            <b-form-select size="md"  v-model="$v.form.catname.$model" ref="catname" :state="chkState('catname')" id="catname" name="catname" :class="{ danger: $v.form.catname.$error }"
                :options="CatOptions" value-field="id" text-field="name">
                 <b-form-select-option :value="null">Clear Selected Option</b-form-select-option>
            </b-form-select>


            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
              <b-form-group label="Barcode" label-for="barcode">
                  <b-form-input
                    id="barcode"
                    type="text"
                    :state="chkState('barcode')"
                    v-model.lazy.trim="$v.form.barcode.$model"
                    aria-describedby="liveFeedbackBarcode"
                    placeholder="Enter Barcode"

                  />
                  <b-form-invalid-feedback id="liveFeedbackBarcode">
                    This is a required field. Contains 20 characters
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>        
        </b-row>
        <b-row>
          <b-col cols="6">
              <b-form-group label="Cost Price" label-for="costprice">
                  <b-form-input
                    id="costprice"
                    type="number"
                    :state="chkState('costprice')"
                    v-model.lazy.trim="$v.form.costprice.$model"
                    aria-describedby="liveFeedbackCostPrice"
                    placeholder="Enter Cost Price"

                  />
                  <b-form-invalid-feedback id="liveFeedbackCostPrice">
                    This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>
          <b-col cols="6">
              <b-form-group label="Sell Price" label-for="sellprice">
                  <b-form-input
                    id="sellprice"
                    type="number"
                    :state="chkState('sellprice')"
                    v-model.lazy.trim="$v.form.sellprice.$model"
                    aria-describedby="liveFeedbackSellPrice"
                    placeholder="Enter Sell Price"

                  />
                  <b-form-invalid-feedback id="liveFeedbackSellPrice">
                    This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">                               
              <b-form-group label="Current Stock" label-for="stock_in_hand">
                  <b-form-input
                    type="number" 
                    id="stock_in_hand" 
                    :state="chkState('stock_in_hand')"
                    v-model="$v.form.stock_in_hand.$model"
                    placeholder="Enter Stock In Hand"
                    
                  
                  />               
              </b-form-group>
          </b-col>
          <b-col cols="6">
              <b-form-group label="Low Stock Threshold" label-for="low_stock_alert">
                  <b-form-spinbutton min=0 max=10000
                    id="low_stock_alert"                   
                    :state="chkState('low_stock_alert')"
                    v-model="$v.form.low_stock_alert.$model"
                    placeholder="Enter Low Stock Threshold"
                    inline
                  />               
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Product Visible?"  label-for="isvisible">
            <b-form-checkbox :state="chkState('isvisible')" v-model="$v.form.isvisible.$model" id="isvisible" name="isvisible" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Enabled?"  label-for="enabled">
            <b-form-checkbox :state="chkState('enabled')" v-model="$v.form.enabled.$model" id="enabled" name="enabled" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Variable Price?"  label-for="isvariable">
            <b-form-checkbox :state="chkState('isvariable')" v-model="$v.form.isvariable.$model" id="isvariable" name="isvariable" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            </b-form-select>
            <b-form-group
              label="Supplier"
              label-for="supplier">
            <v-select   :options="suppliers" v-model="$v.form.supplier.$model" :reduce="suppliers => suppliers.value" label="text"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-file
               v-model="$v.form.imagefile.$model"
               :state="chkState('imagefile')"
               placeholder="Choose a file or drop it here..."
               drop-placeholder="Drop file here..."
             >
           </b-form-file>
            <div class="mt-3">Selected file: {{ form.imagefile ? form.imagefile.name : '' }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
              Save
            </b-button>
          </b-col>
          <b-col>
            <b-button class="ml-1" type="reset" @click="onCancel">Close</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>


import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
  mapState,
  mapActions
} from 'vuex'
import { validationMixin } from "vuelidate";
import filter from 'lodash/filter'
import { required,minLength,numeric, minValue, maxLength,decimal } from "vuelidate/lib/validators";


const formShape = {
  name: null,
  catname: null,
  isvariable: false,
  isvisible: false,
  enabled: false,
  barcode: null,
  supplier: null,
  imagefile: null,
  id: null,
  systemid: null,
  costprice:null,
  sellprice:null,
  taxid: null,
  stock_in_hand: 0,
  low_stock_alert: 0

}

export default{
  name: 'ProductAdd',
  props: {
    systemid: {
      type: Number,
      default: null,
    },

  },

  data: function() {
    return {
      form: Object.assign({}, formShape),
      submitted: false,
    }
  },

  validations: {
    form: {
      imagefile: {        
        },
        supplier:{
          required: false
        },
        barcode:{
          required,
          maxLength : maxLength(20)
        },
        isvisible: {
          required: false,
        },
        isvariable:{
          required
        },
        enabled:{
          required
        },
        catname: {
          required
        },
        name: {
          required
        },
        costprice:{
          required,
          decimal:2
        },
        sellprice:{
          required,
          decimal:2
        },
        stock_in_hand:{                   
          minValue: minValue(0)   
        },
        low_stock_alert:{          
          numeric
        }

    }
  },

  computed: {
    CatOptions(){
      let systemid = this.systemid;
      return filter(this.$store.state.pos.categories,
         function(cat) {
           return (cat.systemid == systemid);
      });
    },
    suppliers(){
      return []
      // TO DO: Make supplier api
      //return this.$store.state.pos.suppliers
    }

  },



  methods:{
    onCancel() {
      this.onReset();
      this.$emit('cancel')
    },
    onSubmit(){

      if(this.validate() & this.submitted == false){
        this.$nextTick(() => {
          
          if(!/^[0-9]+$/.test(this.form.stock_in_hand)){
            this.showErrorMsg({
                  message: "Please only enter numeric characters only for Current Stock"
                })
            return;
          }
          this.submitted = true
          let params = {
            systemid: this.form.systemid,
            id: this.form.id,
            barcode: this.form.barcode,
            name: this.form.name,
            enabled: this.form.enabled,
            isvariable: this.form.isvariable,
            isvisible: this.form.isvisible,
            costprice: this.form.costprice,
            sellprice: this.form.sellprice,
            taxid: this.form.taxid,
            imagefile: this.form.imagefile,
            catid: this.form.catname,
            supid: this.form.supplier,
            stock_in_hand: this.form.stock_in_hand,
            low_stock_alert: this.form.low_stock_alert
          };

          this.$store
            .dispatch('pos/addProduct', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                this.showSuccessMsg({
                  message: 'Record added successfully.'
                });
                this.$emit('success')
              }
              this.submitted = false;

            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
              }
              this.submitted = false;
            })
        })

      }

    },
    validate() {
      this.$v.$touch()
      return !this.$v.form.$anyError
    },

    chkState(name){
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onReset() {
      this.form = formShape
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },


  },

  created: function(){
    if (this.$store.state.pos.categories.length == 0) {
      this.$store.dispatch('pos/getCategories');
    }

    this.form = Object.assign({}, formShape);

    this.form.systemid = this.systemid;

  }
}
</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
